import React from 'react';

let insertionSortContent = {
                            'videos': {
                                'intuition': 'https://www.youtube.com/embed/8uZMzqvg6sI',
                                'analysis': 'https://www.youtube.com/embed/piaGz_TA9tQ',
                                'songAndCode': 'https://www.youtube.com/embed/EyDQ8wSk9HM',
                            },
                            'img': (
                                <img src={'./sortedListThick2.png'} style={{"width": "460px", "maxWidth": "100%"}} />
                            ),
                            'intuition': ( 
                                <div style={{'paddingLeft':'10%','paddingRight':'10%',}}>
                                      <p>Insertion sort might be the most intuitive sorting algorithm.
                                          It works be repeatedly finding where the next element should go 
                                          among those to its left. See animated examples of how it works and gain
                                          intuition for this cool algorithm.</p>
                                </div>
                            ),
                            'analysis': (
                                    <ul>
                                        <li>Quick big-O notation explanation</li>
                                        <li>Understand best case runtime of insertion sort</li>
                                        <li>Understand worst case runtime of insertion sort.</li>
                                    </ul>
                            ),
                            'songAndCode': (
                                    <ul>
                                        <li>Part 1: Hear the insertion sort song which will help you remember how to program insertion sort.</li>
                                        <li>Part 2: Watch me demonstrate how to use the song lyrics to implement the algorithm in Python.</li>
                                    </ul>     
                            ),
}
export default insertionSortContent



// WEBPACK FOOTER //
// ./src/AlgoPageContent/insertion-sort/content.jsx